import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { ICheckValidExceptionName } from '../../../models';

/**
 * Custom hook to call schema api
 * @returns promise
 */
const useException = () => {
  async function callGetExceptionApi(name: string) {
    const { responseBody, isError, error, statusCode } = await apiWrapper.get<ICheckValidExceptionName[]>(
      `${process.env.REACT_APP_API_BASE_URL}/exceptions/${name}/status/active`,
      headersInstance()
    );

    if (isError) {
      throw error;
    }

    return {
      data: responseBody,
      status: statusCode
    };
  }

  const exceptionNameValidChecker = (eName: string) => callGetExceptionApi(eName);

  return { exceptionNameValidChecker };
};

export default useException;
